/* Estilos do dropdown pesquisável */
.ss {
  position: relative;
  width: 100%;
  min-width: 100%;
}

.ss-toggle {
  width: 100%;
  min-height: 44px;
  padding: 10px 12px;
  border: 1px solid var(--panel-border);
  border-radius: 12px;
  background: #fff;
  color: var(--text);
  text-align: left;
  cursor: text;
  font-size: 14px;
  transition: var(--transition);
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
}

.ss-toggle span {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.ss-toggle:hover {
  border-color: var(--primary);
}

.ss-toggle:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37,99,235,.12);
}

.ss-toggle:disabled,
.ss-toggle-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ss-toggle-open {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37,99,235,.12);
}

.ss-toggle .ss-placeholder {
  color: var(--muted);
}

/* Input integrado no SmartSelect */
.ss-input {
  flex: 1 1 auto;
  width: 0;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: inherit;
  font-family: inherit;
  color: var(--text);
}

.ss-input::placeholder {
  color: var(--muted);
}

.ss-input:disabled {
  cursor: not-allowed;
}

/* Botão limpar */
.ss-clear-btn {
  flex-shrink: 0;
  padding: 2px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  display: flex;
  align-items: center;
}

.ss-clear-btn:hover {
  color: #6b7280;
}

/* Chevron / seta do dropdown */
.ss-chevron {
  flex-shrink: 0;
  color: #9ca3af;
  display: flex;
  align-items: center;
}

.ss-chevron svg {
  transition: transform 0.2s;
}

.ss-chevron-open {
  transform: rotate(180deg);
}

/* Spinner animation */
.ss-spinner {
  animation: ss-spin 1s linear infinite;
}

@keyframes ss-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.ss-panel {
  background: #fff;
  border: 1px solid var(--panel-border);
  border-radius: 12px;
  box-shadow: var(--shadow);
  padding: 8px;
  min-width: 280px;
  max-width: 450px;
  width: max-content;
}

/* Estilos de posição apenas para dropdown NÃO-portal (dentro do fluxo normal) */
.ss-panel:not(.ss-panel-portal) {
  position: absolute;
  z-index: 1300;
  top: calc(100% + 6px);
  left: 0;
}

/* Estilo especial para dropdown renderizado via portal */
/* NOTA: NÃO usar !important em top/left/bottom/right pois são definidos via JavaScript inline */
/* z-index alto (100001) para aparecer acima de modais (que usam 99999/100000) */
.ss-panel-portal {
  position: fixed !important;
  z-index: 100001 !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.ss-search {
  width: 100%;
  min-height: 36px;
  padding: 8px 12px;
  border: 1px solid var(--panel-border);
  border-radius: 10px;
  background: #fff;
  color: var(--text);
  font-size: 14px;
  outline: none;
  transition: var(--transition);
}

.ss-search:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37,99,235,.12);
}

.ss-list {
  margin-top: 0;
  max-height: 280px;
  overflow-y: auto;
  padding: 4px 0;
}

.ss-item {
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: var(--text);
  transition: var(--transition);
  word-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
}

.ss-item:hover, .ss-item[aria-selected="true"] {
  background: #f3f4f6;
  color: var(--primary);
}

.ss-empty {
  padding: 12px;
  color: var(--muted);
  text-align: center;
  font-size: 14px;
}

/* Desktop - dropdown should not affect parent layout */
@media (min-width: 1024px) {
  .ss {
    width: 100%;
  }

  .ss-toggle {
    width: 100%;
  }

  .ss-toggle span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ss-panel {
    min-width: 320px;
    max-width: 500px;
    width: max-content;
  }
}

@media (min-width: 720px) and (max-width: 1023px) {
  .ss {
    width: 100%;
  }

  .ss-toggle {
    width: 100%;
  }

  .ss-toggle span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ss-panel {
    min-width: 300px;
    max-width: 400px;
    width: max-content;
  }
}

/* Mobile and Tablet - constrained width for better UX */
@media (max-width: 719px) {
  .ss-toggle {
    min-height: 44px;
    padding: 12px 14px;
    font-size: 16px; /* Prevents zoom on iOS */
  }

  .ss-search {
    min-height: 40px;
    padding: 10px 12px;
    font-size: 16px; /* Prevents zoom on iOS */
  }

  .ss-item {
    padding: 12px 14px;
    font-size: 14px;
    min-height: 44px;
    display: flex;
    align-items: center;
  }

  /* Apenas para dropdown NÃO-portal */
  .ss-panel:not(.ss-panel-portal) {
    max-height: 60vh;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    left: 0;
    right: 0;
  }

  .ss-list {
    max-height: calc(60vh - 80px);
  }
}

@media (max-width: 480px) {
  /* Apenas para dropdown NÃO-portal */
  .ss-panel:not(.ss-panel-portal) {
    left: 0;
    right: 0;
    max-height: 50vh;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }

  .ss-list {
    max-height: calc(50vh - 70px);
  }
}
